export default __webpack_public_path__ + "static/media/fiercely-independent-img1.fe297f08.jpg";